import { TCustomComponent } from '@/type/ui/ui.type';
import { twMerge } from 'tailwind-merge';

interface SingleIconButtonProps {
  icon: React.ComponentType<TCustomComponent>;
  buttonClassName?: string;
  iconClassName?: string;
  dataModalToggle?: string;
  disabled?: boolean;
  onClick?: () => void;
}

export const SingleIconButton = ({
  icon: Icon,
  buttonClassName,
  iconClassName,
  dataModalToggle,
  disabled,
  onClick,
}: SingleIconButtonProps) => {
  return (
    <div
      className={twMerge(
        'flex justify-center items-center cursor-pointer',
        disabled && 'opacity-50 cursor-not-allowed',
        buttonClassName,
      )}
      data-modal-toggle={dataModalToggle}
      onClick={disabled ? (e) => {e.stopPropagation()} : onClick}
    >
      <Icon className={twMerge('w-4 h-4 [&>path]:fill-black', iconClassName)} />
    </div>
  );
};
